import { HeroSection } from "./HeroSection";
import { TrustBarSection, ProblemSection, ProductSection } from "./ContentSections";
import {
  HowItWorksSection,
  LiveSessionsSection,
  WorkspaceMemorySection,
  FlowCanvasSection,
  SolutionsSection,
  WorkspaceAiSection,
} from "./FeatureSections";
import { PricingSection, MarketingFooter } from "./PricingSection";

export function MarketingHomeContent() {
  return (
    <>
      <HeroSection />
      <TrustBarSection />
      <ProblemSection />
      <ProductSection />
      <HowItWorksSection />
      <LiveSessionsSection />
      <WorkspaceMemorySection />
      <FlowCanvasSection />
      <SolutionsSection />
      <WorkspaceAiSection />
      <PricingSection />
      <MarketingFooter />
    </>
  );
}
